import { render, staticRenderFns } from "./apimessagedetails.vue?vue&type=template&id=21402a24&scoped=true&"
import script from "./apimessagedetails.vue?vue&type=script&lang=js&"
export * from "./apimessagedetails.vue?vue&type=script&lang=js&"
import style0 from "./apimessagedetails.vue?vue&type=style&index=0&id=21402a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21402a24",
  null
  
)

export default component.exports